import { DatePipe, DecimalPipe } from '@angular/common';
import { Component, OnInit, AfterViewInit, ViewChild, Inject } from '@angular/core';
import { TableComponent } from '@unilog/ng9-table';
import { forkJoin, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GeneralService } from '../services/general.service';
import * as _ from 'lodash';
import { MatTable } from '@angular/material/table';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { DateRange } from '@angular/material/datepicker';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit, AfterViewInit {

  @ViewChild("tableMensuel") tableMensuel: MatTable<any>;
  @ViewChild("tableJournalier") tableJournalier: MatTable<any>;


  Machine_Code;

  debutPoste;
  finPoste;



  api = this.generalService.api;

  displayedColumns = [
    'Operateur', 'Gain', 'NbPoteaux', 'TonageMensuel', 'Score'
  ];

  displayedColumns2 = [
    'Operateur', 'OF', 'Designation', 'Avancement', 'Objectif DJ', 'Prix', 'Gain'
  ];

  dataSource;
  dataSourceDaily;
  OFDGP;

  dateAujourdhui;
  msg = "";

  dataHorairesPostes = [];
  connectedEmployees = "";


  constructor(
    private generalService: GeneralService,
    private datePipe: DatePipe,
    private route: ActivatedRoute,
    private http: HttpClient,
  ) {
    datePipe = new DatePipe('en-US');
  }

  getMinutes(d: Date) {
    return d.getHours() * 60 + d.getMinutes();
  }



  async calculheuresPoste() {

    let dataHorairesPostes: any[] = await this.generalService.rechercheTable('API_Horaire_Poste').toPromise();

    let now = this.getMinutes(new Date());


    let debutPoste2 = new Date();
    let finPoste2 = new Date();


    debutPoste2.setSeconds(0);
    finPoste2.setSeconds(0);

    dataHorairesPostes.forEach(poste => {
      let ddeb: Date = new Date("1/1/2000 " + poste.xHoraire_HeureDebut);
      let dfin: Date = new Date("1/1/2000 " + poste.xHoraire_HeureFin);

      let mdeb = this.getMinutes(ddeb);
      let mfin = this.getMinutes(dfin);


      if (now >= mdeb && now <= mfin) {
        debutPoste2.setHours(ddeb.getHours());
        debutPoste2.setMinutes(ddeb.getMinutes());

        finPoste2.setHours(dfin.getHours());
        finPoste2.setMinutes(dfin.getMinutes());
      }
      if (mdeb >= mfin && now <= mfin) {
        debutPoste2.setHours(ddeb.getHours());
        debutPoste2.setMinutes(ddeb.getMinutes());
        debutPoste2.setDate(debutPoste2.getDate() - 1);


        finPoste2.setHours(dfin.getHours());
        finPoste2.setMinutes(dfin.getMinutes());
      }

    })


    this.debutPoste = this.getFormatedDate(debutPoste2);
    this.finPoste = this.getFormatedDate(finPoste2);

  }

  getFormatedDate(d: Date) {
    return this.datePipe.transform(d.toISOString(), 'yyyyMMdd HH:mm');
  }

  async ngOnInit() {

    this.route.queryParams.subscribe(async params => {
      this.Machine_Code = params.Machine_Code;

     
      await this.calculheuresPoste();
      this.dateAujourdhui = this.getFormatedDate(new Date());
      this.refreshConnectedUsers();
      this.refreshDailyTable();
      this.refreshMonthlyTable();
      this.fetchPlanOFMachine();
      this.fetchMessage();
    }
    );


  }

  fetchMessage(){
    this.generalService.rechercheTablewithparam("API_MessageMachine",this.Machine_Code).subscribe(res=>{
      this.msg = res[0]["message"];
    });
  }

  refreshConnectedUsers() {

    this.generalService.rechercheTablewithparam("apiConnectedUsers", this.Machine_Code + "," + this.debutPoste).subscribe(res => {
      var arr = [];
      res.forEach(row => {
        if (res.filter(x => x.Perso_Matricule)[0].PDAPersoPointage_Type == "0" && arr.findIndex(x => x.Perso_Matricule == row.Perso_Matricule) == -1)
          arr.push(row);
      });
      this.connectedEmployees = arr.map(x => x.Perso_Prenom + " " + x.Perso_Nom).join(", ");
    });

  }

  refreshDailyTable() {
    this.generalService.rechercheTable("API_Rendement&param=" + this.Machine_Code + "," + this.debutPoste + "," + this.finPoste).subscribe((res: any[]) => {
      res.forEach(element => {
        element.Realise = element.Realisé;
      });
      //this.tableRendementQuotidientMachine.setDataSource(res);
      this.dataSourceDaily = res;
    })
  }

  refreshMonthlyTable() {
    var date = new Date();
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);

    var _url = this.generalService.api + "msgi/DashboardProd_Mensuel?Machine_Code=" + this.Machine_Code + "&dateDebut=" + this.getFormatedDate(firstDay) + "&dateFin=" + this.finPoste;

    this.http.get(_url).subscribe((res: any[]) => {
      this.dataSource = res.sort((a, b) => b.Score - a.Score).slice(0, 7);

    })
  }

  fetchPlanOFMachine() {
    this.generalService.rechercheTable("API_PlanOFMachine&param=" + this.Machine_Code).subscribe(data => {
      
      data.map( x => x.DaysLeft =   (Date.parse(x.OFDGP_Fin)-new Date().getTime())/(1000*3600*24))
      data.map( x =>  x.operateurs = [ x.operateur1, x.operateur2, x.operateur3 ].filter(y => y != null && y != "" ).join(' + '));
      data.sort( (a,b) =>  a.DaysLeft - b.DaysLeft );

      this.OFDGP = data;
      console.log(this.OFDGP);

    });
  }


  ngAfterViewInit() {
    setInterval(() => {
      this.dateAujourdhui = this.getFormatedDate(new Date());
      this.refreshConnectedUsers();
      this.refreshDailyTable();
      this.refreshMonthlyTable();
      this.fetchPlanOFMachine();
      this.fetchMessage();
    }, 30000);
  }

}
